module.exports = __webpack_public_path__ + "static/media/sass.6c5897a8.svg";